import { type NewUserPayload } from './uiOnboarding';
import { type COMPLETE_ONBOARDING } from '~shared/constants';

export const VERIFICATION_COMMS_CHANNEL = Object.freeze({
  email: 'email',
  sms: 'sms',
  call: 'call',
});
export type VerificationCommsChannel = keyof typeof VERIFICATION_COMMS_CHANNEL;
export type VerificationReason = 'duplicate_account';

export type StartVerificationParams = {
  comms_channel: VerificationCommsChannel | null | undefined;
  uuid: string | null | undefined;
  reason: VerificationReason;
};

export type CompleteVerificationParams = {
  comms_channel: VerificationCommsChannel | null | undefined;
  code: string;
  uuid: string | null | undefined;
};

export type ActionCompleteOnboarding = {
  type: typeof COMPLETE_ONBOARDING;
};

export const SET_ONBOARDING_VERIFICATION_CHANNEL = 'SET_ONBOARDING_VERIFICATION_CHANNEL';
export type ActionSetOnboardingVerificationChannel = {
  type: typeof SET_ONBOARDING_VERIFICATION_CHANNEL;
  payload: VerificationCommsChannel | null | undefined;
};
export function setOnboardingVerificationChannel(channel: VerificationCommsChannel | null | undefined) {
  return {
    type: SET_ONBOARDING_VERIFICATION_CHANNEL,
    payload: channel,
  };
}

export const SET_ONBOARDING_VERIFICATION_REQUIRED = 'SET_ONBOARDING_VERIFICATION_REQUIRED';
export type ActionSetOnboardingVerificationRequired = {
  type: typeof SET_ONBOARDING_VERIFICATION_REQUIRED;
};
export function setOnboardingVerificationRequired() {
  return {
    type: SET_ONBOARDING_VERIFICATION_REQUIRED,
  };
}

export const SET_ONBOARDING_VERIFICATION_USER = 'SET_ONBOARDING_VERIFICATION_USER';
export type ActionSetOnboardingVerificationUser = {
  type: typeof SET_ONBOARDING_VERIFICATION_USER;
  payload: NewUserPayload;
};
export function setOnboardingVerificationUser(user: NewUserPayload) {
  return {
    type: SET_ONBOARDING_VERIFICATION_USER,
    payload: user,
  };
}

export const CLEAR_ONBOARDING_VERIFICATION_REQUIRED = 'CLEAR_ONBOARDING_VERIFICATION_REQUIRED';
export type ActionClearOnboardingVerificationRequired = {
  type: typeof CLEAR_ONBOARDING_VERIFICATION_REQUIRED;
};
export function clearOnboardingVerificationRequired() {
  return {
    type: CLEAR_ONBOARDING_VERIFICATION_REQUIRED,
  };
}
